




















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import DefaultWorkflowJob from '@/components/workflow/DefaultWorkflowJob.vue';
import {
  JobTabStateModel,
  WorkflowJobTabsToHideModel,
  TabStateModel,
  FieldUpdateModel,
  WorkflowJobButtonModel,
  WorkflowStandardProcessingAction,
  WorkflowJobTabModel,
  DocumentViewerConstants,
  NotificationConstants,
  EditReferencesButtonTooltipModel,
  DocumentSearchModel
} from '@/types';
import { SignersTabService } from '@/services/docuSign/SignersTabService';
import { EventBus } from '@/classes/EventBus';
import { DocuSignWorkflowJob, ObjectHelper } from '@/mixins';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'DocuSignWorkflowJob',
  mixins: [DefaultWorkflowJob, DocuSignWorkflowJob, ObjectHelper],
  data() {
    return {
      leftPaneSize: 0,
      rightPaneSize: 0
    };
  },
  methods: {
    ...mapActions('docuSignWorkflowJobStore', ['unloadDocuSignWorkflowJob']),
    onDeleteDocument(this: any, documentSearchModel: DocumentSearchModel) {
      this.reloadRelatedDocumentsTab(documentSearchModel);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['isWorkflowJobLocked', 'workflowDataSourceField', 'jobTabState']),
    ...mapGetters('docuSignWorkflowJobStore', ['signersTab']),
    editReferencesTooltip(this: any): EditReferencesButtonTooltipModel | null {
      if (this.isWorkFlowJobDirty) {
        return {
          disabledTooltipMessage: NotificationConstants.CannotEditDocumentLinkedToUpdatedWorkflowJob,
          important: false
        };
      } else {
        return null;
      }
    }
  },
  mounted(this: any) {
    this.initializeCanGetNextJob();
  },
  beforeDestroy(this: any) {
    this.unloadDocuSignWorkflowJob();
  },
  components: {
    LoadingSpinner
  },
  created(this: any) {
    this.documentToolbarOptions = DocumentViewerConstants.DocumentViewerDeleteEnabledToolOptions;
  }
});
